<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OMultiSelect v-model="model" :placeholder="placeholder" :disabled="normalizedDisabled" :code="code" multiple
        :collapse-tags="collapseTags" :collapse-tags-tooltip="collapseTagsTooltip" @change="(attrs.onChange)">
      </OMultiSelect>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { ElCol, ElFormItem } from 'element-plus'
import type { FormMultiSelectProps } from './MultiSelect'
import OMultiSelect from '../../Input/MultiSelect/MultiSelect.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'

defineOptions({ name: 'OFormMultiselect', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, placeholder, code, collapseTags, collapseTagsTooltip } = defineProps<FormMultiSelectProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
